<template>
  <div>
    <span class="text-primary">
      {{ selectedCustomer.invoice_company }}<br>
      <template v-if="selectedCustomer.name || selectedCustomer.surname">
        <small>{{ selectedCustomer.name }} {{ selectedCustomer.surname }}</small><br>
      </template>
    </span>
    <p
      v-if="selectedCustomer.debt_amount > 0"
      class="text-danger mt-1">
      Wybrany klient jest zadłużony.
    </p>
    <template v-if="hasDiscount">
      <div class="mb-2">
        <d-link
          class="dropdown-toggle text-warning"
          v-d-toggle.discounts-collapse
          style="font-size: 14px;"
          @click.native="handleToggle()">
          <template v-if="detailsVisible">
            Ukryj rabaty
          </template>
          <template v-else>
            Pokaż rabaty
          </template>
        </d-link>
        <d-collapse
          id="discounts-collapse"
          class="pl-2"
          accordion="sidebar-items-accordion">
          <small>
            Podstawowy:
            <strong class="text-success">{{ selectedCustomer.discount }}%</strong>
          </small>
          <div v-if="selectedCustomer.products.length">
            <small>Rabaty dla produktów:</small>
            <div
              v-for="(discount, index) of selectedCustomer.products"
              :key="'product-discount-' + index"
              class="flex pl-2">
              <small>
                <strong class="text-primary">
                  {{ getProductName(discount.id) }}:
                </strong>
              </small>
              <small>
                <strong class="text-success pl-1">
                  {{ discount.discount }}%
                </strong>
              </small>
            </div>
          </div>
          <div v-if="selectedCustomer.manufacturers.length">
            <small>Rabaty producentów:</small>
            <div
              v-for="(discount, index) of selectedCustomer.manufacturers"
              :key="'manufacturer-discount-' + index"
              class="flex pl-2">
              <small>
                <strong class="text-primary">
                  {{ getManufacturerName(discount.id) }}:
                </strong>
              </small>
              <small>
                <strong class="text-success pl-1">
                  {{ discount.discount }}%
                </strong>
              </small>
            </div>
          </div>
          <div v-if="selectedCustomer.categories.length">
            <small>Rabaty dla kategorii produktów:</small>
            <div
              v-for="(discount, index) of selectedCustomer.categories"
              :key="'category-discount-' + index"
              class="flex pl-2">
              <small>
                <strong class="text-primary">
                  {{ getCategoryName(discount.id) }}:
                </strong>
              </small>
              <small>
                <strong class="text-success pl-1">
                  {{ discount.discount }}%
                </strong>
              </small>
            </div>
          </div>
          <div class="pt-1">
            <small class="text-danger pt-1">Powyżej przedstawiono aktualne rabaty (w momencie tworzenia zamówienia ich stan mógł być inny).</small>
          </div>
        </d-collapse>
      </div>
    </template>
    <template v-else>
      <small class="text-warning">
        Aktualnie klient nie ma rabatów (w momencie tworzenia zamówienia ich stan mógł być inny).
      </small>
    </template>
  </div>
</template>

<script>
export default {
  name: 'order-info-customer',
  props: [
    'selectedCustomer',
    'allCategories',
    'allManufacturers',
    'allProducts'
  ],
  computed: {
    hasDiscount () {
      return this.selectedCustomer.discount || this.selectedCustomer.categories.lngth || this.selectedCustomer.manufacturers.length || this.selectedCustomer.products.length;
    }
  },
  data () {
    return {
      detailsVisible: false
    }
  },
  methods: {
    handleToggle() {
      this.detailsVisible = !this.detailsVisible;
    },
    getProductName (productID) {
      let theProduct = this.allProducts.find(product => product.id === productID);

      if (theProduct) {
        return theProduct.name;
      }

      return 'Produkt o ID#' + productID + ' już nie istnieje';
    },
    getManufacturerName (manufacturerID) {
      let theManufacturer = this.allManufacturers.find(manufacturer => manufacturer.id === manufacturerID);

      if (theManufacturer) {
        return theManufacturer.name;
      }

      return 'Producent o ID#' + manufacturerID + ' już nie istnieje';
    },
    getCategoryName (categoryID) {
      let theCategory = this.allCategories.find(category => category.id === categoryID);

      if (theCategory) {
        return theCategory.name;
      }

      return 'Kategoria o ID#' + categoryID + ' już nie istnieje';
    }
  }
}
</script>
